import { OptionLike } from "helpers/OptionHelper";
import { BaseModel } from "./BaseModel";
import { Concessionaire } from "./Concessionaire";
import { Highway } from "./Highway";
import { HighwayConcessionData, HighwayProps } from "./types";

export class HighwayConcession extends BaseModel<HighwayConcessionData> {
	id: string;
	imageUrl: string;
	concessionaire: Concessionaire;
	highway: Highway;

	constructor(data: HighwayConcessionData) {
		super(data);
		this.id = data.id;
		this.imageUrl = data.imageUrl;
		this.concessionaire = Concessionaire.getValueOrNew(data.concessionaire);
		this.highway = Highway.getValueOrNew(data.highway);
	}

	toString() {
		return `${this.highway.name} (${this.highway.code}) - ${this.concessionaire.name}`;
	}

	toShortString() {
		return `${this.highway.name} (${this.highway.code})`;
	}

	toOption = (): OptionLike => {
		return { ...this, label: this.toString(), value: this.id };
	};

	static createFromResponse(response: HighwayConcessionData) {
		if (!response) {
			return response;
		}

		const highwayData: HighwayProps = response.highway || {
			name: response.highwayName,
			code: response.highwayCode
		};

		return new this({
			...response,
			highway: highwayData
		});
	}
}
